import {
  KgInsightFilterRequest,
  KgInsightFilterResponse,
  kgInsights,
} from '@api';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_KG_INSIGHT_FILTER = 'QUERY_KEY_KG_INSIGHT_FILTER';

export const useKgInsightFilter = (
  body: KgInsightFilterRequest,
  isEnabled = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_KG_INSIGHT_FILTER, body],
    queryFn: ({ signal }) => {
      const { path, schema } = kgInsights.postKgInsightFilter;
      return wretchRequest<KgInsightFilterResponse>(path, {
        method: 'post',
        body,
        schema,
        signal,
      });
    },
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
  });
